import { render } from "./GatewaySection.vue?vue&type=template&id=36c782a1"
import script from "./GatewaySection.vue?vue&type=script&lang=js"
export * from "./GatewaySection.vue?vue&type=script&lang=js"
script.render = render

export default script